import { SiteModel } from '@shared/models';
import { ClusterSite } from '@shared/models/Clusters';
import { styleConstants } from '@styles/constants';

export enum SiteState {
  Ok = 'Ok',
  Flatline = 'Flatline',
  Quiet = 'Quiet',
  PressureFault = 'PressureFault',
  Other = 'Other',
}

export const getSiteColor = (site: SiteModel | ClusterSite): string => {
  if (!site) return getSiteColorByState(SiteState.Other);
  if (site.isFlatLine) return getSiteColorByState(SiteState.Flatline);
  if (site.isQuiet) return getSiteColorByState(SiteState.Quiet);
  if (site.isPressureFault) return getSiteColorByState(SiteState.PressureFault);

  return getSiteColorByState(SiteState.Ok);
};

export const getSiteColorByState = (siteState: SiteState): string => {
  switch (siteState) {
    case SiteState.Flatline:
      return styleConstants.colors.sites.flatline;
    case SiteState.Quiet:
      return styleConstants.colors.sites.quiet;
    case SiteState.PressureFault:
      return styleConstants.colors.sites.pressureFault;
    default:
      return styleConstants.colors.sites.ok;
  }
};

export const getMastColor = (): string => styleConstants.colors.darkBlue;
